<template>
  <base-card-vue>
    <base-button-vue
      @click="setSelectedTab('stored-resources-vue')"
      :mode="storedResBtnMode"
      >Stored Resources</base-button-vue
    >
    <base-button-vue
      @click="setSelectedTab('add-resource-vue')"
      :mode="addResBtnMode"
      >Add Resource</base-button-vue
    >
  </base-card-vue>
  <keep-alive>
    <component :is="selectedTab"></component>
  </keep-alive>
</template>

<script>
import AddResourceVue from './AddResource.vue';
import StoredResourcesVue from './StoredResources.vue';

export default {
  components: {
    AddResourceVue,
    StoredResourcesVue,
  },
  data() {
    return {
      selectedTab: 'stored-resources-vue',
      storedResources: [
        {
          id: 'abc123',
          title: 'Official Vue Guide',
          description: 'Official Vue.js Documentation',
          link: 'https://vuejs.org',
        },
        {
          id: 'abc345',
          title: 'Google Search',
          description: 'Use Google to search for things',
          link: 'https://google.com',
        },
      ],
    };
  },
  methods: {
    setSelectedTab(tab) {
      this.selectedTab = tab;
    },
    addNewResource(resource) {
      console.log('RESOURCE', resource);
      if (resource) {
        this.storedResources.unshift(resource);
        this.selectedTab = 'stored-resources-vue';
      }
    },
    deleteResource(id) {
      console.log('ID', id);

      const resIndex = this.storedResources.findIndex((r) => r.id == id);
      console.log('INDEX', resIndex);

      this.storedResources.splice(resIndex, 1);
    },
  },
  provide() {
    return {
      resources: this.storedResources,
      addNewResource: this.addNewResource,
      deleteResource: this.deleteResource,
    };
  },
  computed: {
    storedResBtnMode() {
      return this.selectedTab === 'stored-resources-vue' ? null : 'flat';
    },
    addResBtnMode() {
      return this.selectedTab === 'add-resource-vue' ? null : 'flat';
    },
  },
};
</script>

<style></style>
